module.exports = __webpack_public_path__ + "static/img/2-6.5.5.1085105.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/5/2-6.5.5.png
// module id = k3Yg
// module chunks = 0